<div class="d-flex align-items-center">
  <div class="container">
    <div
      *ngIf="providerInfo && providerInfo.providerContract && providerInfo.providerContract.externalWebsiteAbout"
      [innerHTML]="providerInfo.providerContract.externalWebsiteAbout | htmlWithStyle"
    ></div>
  </div>
</div>
